module.exports = __webpack_public_path__ + "static/media/use-case.abdb5ba1.svg";